export default __webpack_public_path__ + "static/media/afternoon.9aaf6810.png";